/* NAUGHTY GRANNY — scripts propios (prefijo ng-) */
(function () {
  if (window.__ngInit) return;
  window.__ngInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('ng-visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;

  function splitWords(el) {
    if (el.dataset.ngSplit) return;
    el.dataset.ngSplit = '1';
    var i = 0;
    Array.prototype.slice.call(el.childNodes).forEach(function walk(node) {
      if (node.nodeType === 3) {
        var parts = node.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        parts.forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var w = document.createElement('span'); w.className = 'ng-word';
          var inner = document.createElement('span'); inner.textContent = p; inner.style.setProperty('--i', i++);
          w.appendChild(inner); frag.appendChild(w);
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1 && node.tagName !== 'BR') {
        Array.prototype.slice.call(node.childNodes).forEach(walk);
      }
    });
  }

  function initReveals(root) {
    root.querySelectorAll('.ng-words').forEach(splitWords);
    root.querySelectorAll('.ng-reveal, .ng-words, [data-ng-reveal]').forEach(function (el) {
      if (el.dataset.ngObs) return; el.dataset.ngObs = '1';
      if (!io || reduce) { el.classList.add('ng-visible'); return; }
      io.observe(el);
    });
  }

  /* ---------- Marquesina: duplica hasta cubrir 2x ---------- */
  function initMarquees(root) {
    root.querySelectorAll('[data-ng-marquee]').forEach(function (m) {
      if (m.dataset.ngInit) return; m.dataset.ngInit = '1';
      var pista = m.querySelector('.ng-marquee__pista'); if (!pista) return;
      var base = pista.innerHTML, n = 0;
      while (pista.scrollWidth < m.offsetWidth * 2 && n < 12) { pista.insertAdjacentHTML('beforeend', base); n++; }
      pista.innerHTML = pista.innerHTML + pista.innerHTML;
    });
  }

  /* ---------- Lookbook: arrastrar + flechas suaves ---------- */
  function ease(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function initLooks(root) {
    root.querySelectorAll('[data-ng-look]').forEach(function (sec) {
      if (sec.dataset.ngInit) return; sec.dataset.ngInit = '1';
      var pista = sec.querySelector('.ng-look__pista'); if (!pista) return;
      var items = pista.children;
      function paso() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : pista.clientWidth; }
      function ir(dir) {
        var p = paso(), from = pista.scrollLeft;
        var to = Math.max(0, Math.min(pista.scrollWidth - pista.clientWidth, Math.round(from / p + dir) * p));
        if (reduce) { pista.scrollLeft = to; return; }
        var t0 = null; pista.classList.add('ng-animando');
        requestAnimationFrame(function step(ts) {
          if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / 750);
          pista.scrollLeft = from + (to - from) * ease(k);
          if (k < 1) requestAnimationFrame(step); else pista.classList.remove('ng-animando');
        });
      }
      var prev = sec.querySelector('[data-ng-prev]'), next = sec.querySelector('[data-ng-next]');
      if (prev) prev.addEventListener('click', function () { ir(-1); });
      if (next) next.addEventListener('click', function () { ir(1); });
      var down = false, sx = 0, sl = 0, moved = false;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = pista.scrollLeft; pista.classList.add('ng-arrastrando');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; pista.scrollLeft = sl - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return; down = false; pista.classList.remove('ng-arrastrando');
        var p = paso(); pista.scrollTo({ left: Math.round(pista.scrollLeft / p) * p, behavior: reduce ? 'auto' : 'smooth' });
      });
      pista.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Dinero ---------- */
  function money(cents, fmt) {
    fmt = fmt || '{{amount}}';
    var n = (cents / 100);
    function fix(v, dec, th, dc) {
      var s = v.toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s.length > 1 ? s[0] + dc + s[1] : s[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fix(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fix(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(n, 2, "'", '.');
        default: return fix(n, 2, ',', '.');
      }
    });
  }

  /* ---------- Formulario de producto (combo + PDP) ---------- */
  function initForms(root) {
    root.querySelectorAll('[data-ng-form]').forEach(function (wrap) {
      if (wrap.dataset.ngInit) return; wrap.dataset.ngInit = '1';
      var dataEl = wrap.querySelector('[data-ng-variantes]');
      var form = wrap.querySelector('form');
      if (!form) return;
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = wrap.getAttribute('data-money') || '{{amount}}';
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-ng-submit]');
      var btnTxt = btn ? btn.getAttribute('data-texto') : '';
      var agotadoTxt = btn ? btn.getAttribute('data-agotado') : '';
      var fieldsets = wrap.querySelectorAll('[data-ng-opcion]');
      var scope = wrap.closest('.ng-section') || document;

      function seleccion() {
        return Array.prototype.map.call(fieldsets, function (fs) {
          var c = fs.querySelector('input:checked'); return c ? c.value : null;
        });
      }
      function buscar(sel) {
        return variantes.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); });
      }
      function actualizar() {
        var sel = seleccion();
        fieldsets.forEach(function (fs, i) {
          var out = fs.querySelector('[data-ng-valor]'); var chk = fs.querySelector('input:checked'); if (out) out.textContent = chk ? chk.nextElementSibling.textContent : '';
          fs.querySelectorAll('input').forEach(function (inp) {
            var s = sel.slice(); s[i] = inp.value;
            var hay = variantes.some(function (v) { return v.available && v.options.every(function (o, k) { return s[k] == null || o === s[k]; }); });
            inp.closest('.ng-pill').classList.toggle('ng-pill--agotada', !hay);
          });
        });
        var v = buscar(sel);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        scope.querySelectorAll('[data-ng-precio]').forEach(function (el) {
          var html = money(v.price, fmt);
          if (v.compare_at_price && v.compare_at_price > v.price) html += ' <s>' + money(v.compare_at_price, fmt) + '</s>';
          el.innerHTML = html;
        });
        if (btn) {
          btn.disabled = !v.available;
          btn.querySelector('span').textContent = v.available ? btnTxt : agotadoTxt;
        }
        if (wrap.hasAttribute('data-actualiza-url') && window.history && history.replaceState) {
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
        wrap.dispatchEvent(new CustomEvent('ng:variante', { detail: v, bubbles: true }));
      }
      wrap.addEventListener('change', function (e) { if (e.target.closest('[data-ng-opcion]')) actualizar(); });
      if (fieldsets.length) actualizar();

      form.addEventListener('submit', function (e) {
        var cart = document.querySelector('cart-drawer');
        if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return; // envío normal → /cart
        e.preventDefault();
        var err = wrap.querySelector('[data-ng-error]'); if (err) err.hidden = true;
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        var fd = new FormData(form);
        try {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', location.pathname);
        } catch (x) {}
        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) {
            if (err) { err.textContent = res.description || res.message || 'Algo ha fallado. Prueba otra vez.'; err.hidden = false; }
            return;
          }
          cart.renderContents(res);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        }).catch(function () { form.submit(); }).finally(function () {
          if (btn) { btn.removeAttribute('aria-busy'); actualizar(); if (!fieldsets.length) btn.disabled = false; }
        });
      });

      /* Guía de tallas */
      var dlg = scope.querySelector('[data-ng-dialog]');
      wrap.querySelectorAll('[data-ng-abrir-tallas]').forEach(function (b) {
        b.addEventListener('click', function () { if (dlg && dlg.showModal) dlg.showModal(); });
      });
    });
    root.querySelectorAll('[data-ng-dialog]').forEach(function (d) {
      if (d.dataset.ngInit) return; d.dataset.ngInit = '1';
      d.querySelectorAll('[data-ng-cerrar]').forEach(function (b) { b.addEventListener('click', function () { d.close(); }); });
      d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    });
  }

  /* ---------- Barra fija de compra en móvil ---------- */
  function initSticky(root) {
    root.querySelectorAll('[data-ng-sticky]').forEach(function (bar) {
      if (bar.dataset.ngInit) return; bar.dataset.ngInit = '1';
      var sec = bar.closest('.ng-section');
      var target = sec && sec.querySelector('[data-ng-submit]');
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { bar.classList.toggle('ng-sticky--on', !e.isIntersecting && e.boundingClientRect.top < 0); });
      }).observe(target);
      var b = bar.querySelector('button');
      if (b) b.addEventListener('click', function () { target.click(); });
    });
  }

  /* ---------- Paralaje suave (fotos con data-ng-parallax) ---------- */
  var pars = [];
  function initParallax(root) {
    if (reduce) return;
    root.querySelectorAll('[data-ng-parallax]').forEach(function (el) {
      if (el.dataset.ngInit) return; el.dataset.ngInit = '1'; pars.push(el);
    });
  }
  var ticking = false;
  function loop() {
    ticking = false;
    var vh = window.innerHeight;
    pars.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var v = parseFloat(el.getAttribute('data-ng-parallax')) || 0.15;
      var c = (r.top + r.height / 2 - vh / 2);
      var max = (el.offsetHeight - r.height) / 2;
      var y = Math.max(-max, Math.min(max, -c * v));
      el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
    });
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(loop); } }, { passive: true });

  /* Altura del header para que el héroe quepa entero en la primera pantalla */
  function medirHeader() {
    var h = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) { h += el.offsetHeight; });
    document.documentElement.style.setProperty('--ng-top', h + 'px');
  }
  medirHeader();
  window.addEventListener('resize', medirHeader);


  /* ---------- Barra de anuncios en movimiento ---------- */
  function initTicker() {
    document.querySelectorAll('.announcement-bar__message').forEach(function (msg) {
      if (msg.dataset.ngTicker) return; msg.dataset.ngTicker = '1';
      var span = msg.querySelector('span'); var txt = (span ? span.textContent : msg.textContent).trim();
      if (!txt) return;
      var item = '<span class="ng-ticker__item">' + txt.replace(/</g, '&lt;') + '<i>✦</i></span>';
      msg.innerHTML = '<span class="ng-ticker"><span class="ng-ticker__pista">' + item + '</span></span><span class="visually-hidden">' + txt.replace(/</g, '&lt;') + '</span>';
      var pista = msg.querySelector('.ng-ticker__pista'); var caja = msg.querySelector('.ng-ticker');
      var ancho = (msg.closest('.announcement-bar') || document.documentElement).clientWidth || window.innerWidth;
      var n = 0; while (pista.scrollWidth < ancho * 1.2 && n < 12) { pista.insertAdjacentHTML('beforeend', item); n++; }
      pista.innerHTML = pista.innerHTML + pista.innerHTML;
      pista.style.setProperty('--dur', Math.max(14, pista.scrollWidth / 2 / 60) + 's');
    });
  }


  /* ---------- Pegatinas que se estampan al llegar al pie ---------- */
  function initPegatinas(root) {
    root.querySelectorAll('.ng-footer__escena--collage').forEach(function (esc) {
      if (esc.dataset.ngPega) return; esc.dataset.ngPega = '1';
      if (reduce || !('IntersectionObserver' in window)) return;
      var piezas = Array.prototype.slice.call(esc.querySelectorAll('.ng-polaroid, .ng-adhesivo, .ng-pega, .ng-chapa, .ng-doodle'));
      for (var i = piezas.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = piezas[i]; piezas[i] = piezas[j]; piezas[j] = t; }
      piezas.forEach(function (el, k) { el.style.setProperty('--i', k); });
      esc.classList.add('ng-js-pega');
      function pegar() { esc.classList.add('ng-pegado'); window.removeEventListener('scroll', mirar); }
      function mirar() {
        if (esc.classList.contains('ng-pegado')) return;
        var r = esc.getBoundingClientRect(), vh = window.innerHeight || 800;
        if (r.top < vh * 0.75 && r.bottom > vh * 0.2) pegar();
      }
      new IntersectionObserver(function (es, obs) {
        es.forEach(function (e) { if (e.isIntersecting) { pegar(); obs.disconnect(); } });
      }, { threshold: 0.3 }).observe(esc);
      window.addEventListener('scroll', mirar, { passive: true });
      mirar();
    });
  }

  function initAll(root) {
    root = root || document;
    initTicker(); initPegatinas(root); initReveals(root); initMarquees(root); initLooks(root); initForms(root); initSticky(root); initParallax(root); loop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
